<ng-container *ngIf="isStandardApp">
  <div class="ai-assistant-container">
    <app-ai-chat-window
      *ngIf="config.type == 'chatWindow'"
      [config]="config"
      [isOpen]="isOpen$ | async"
      (closeChat)="onChatClose()"
    >
    </app-ai-chat-window>

    <app-ai-button [config]="config" (buttonClick)="onButtonClick()">
    </app-ai-button>
  </div>

  <app-ai-modal
    *ngIf="config.type === 'modal'"
    [config]="config"
    [isOpen]="isOpen$ | async"
    (closeModal)="onModalClose()"
  >
  </app-ai-modal>
</ng-container>
